import { Backdrop, Box, Fade, Grid, Modal, Typography } from "@mui/material";
import { useState } from "react";
import { DataValidate } from "./dataValidate";
import { NewPassword } from "./newPassword";

const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  justifyContent: "center",
};

export const PasswordModal = ({ open, setOpen, expiredPass, setExpiredPass }) => {
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [username, setUsername] = useState(null);

  const handleClose = () => {
    setShowPasswordForm(false);
    setUsername(null);
    setExpiredPass(false);
    setOpen(false);
  };

  const openPasswordForm = (username) => {
    setUsername(username);
    setShowPasswordForm(true);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              sx={{ p: 0, mb: 2, pr: 1 }}
              className="center_item"
            >
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                {expiredPass ? 'Contraseña expirada' : 'Recuperación de contraseña'}
              </Typography>
            </Grid>
            {!showPasswordForm && (
              <Grid
                item
                xs={12}
                sx={{ p: 0, mb: 2, pr: 1 }}
                className="center_item"
              >
                <DataValidate key="data_validate" nextStep={openPasswordForm} expiredPass={expiredPass}/>
              </Grid>
            )}
            {showPasswordForm && (
              <Grid
                item
                xs={12}
                sx={{ p: 0, mb: 2, pr: 1 }}
                className="center_item"
              >
                <NewPassword key="new_password_form" username={username} handleClose={handleClose}/>
              </Grid>
            )}
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};
